/* START CUSTOMIZATION */
// Upstream renders a semantic-ui Message and drops the thank-you HTML in
// unsanitised. We use the designsystem Message and sanitise both the template
// and every submitted value that gets interpolated into it — submitted data is
// attacker-controlled, so it must never reach dangerouslySetInnerHTML raw.
import { Message } from '@designsystem/stories/03-molecules/Message';
import { sanitize, sanitizeLinksOnly } from '@designsystem/utils/sanitize.ts';
/* END CUSTOMIZATION */

export interface ThankYouProps {
  data: Record<string, any>;
  formfields: string;
  submittedData: Record<string, any>;
}

const ThankYou = ({ data, formfields, submittedData }: ThankYouProps) => {
  let thankyou = data.thankyou || '';

  // Add formfields
  thankyou = thankyou.replace('${formfields}', formfields); // eslint-disable-line no-template-curly-in-string

  // Add seperate fields
  Object.keys(submittedData).forEach((field) => {
    /* START CUSTOMIZATION */
    thankyou = thankyou.replace(
      '${' + field + '}',
      sanitizeLinksOnly(submittedData[field]),
    );
    /* END CUSTOMIZATION */
  });

  /* START CUSTOMIZATION */
  return (
    <div className="submitted">
      <Message type="success" title={data.success} />
      <div
        className="thankyou"
        dangerouslySetInnerHTML={{
          __html: sanitize(thankyou),
        }}
      />
    </div>
  );
  /* END CUSTOMIZATION */
};

export default ThankYou;
